import Highcharts from 'highcharts'
import Accessibility from 'highcharts/modules/accessibility'

Accessibility(Highcharts)

/**
 * Instancia base de Highcharts con solo Accessibility.
 * Usar en SpiderChart, ColumnChart y otros gráficos que no requieren variable-pie.
 */
export default Highcharts
